import React, { useState, useEffect, useRef } from 'react';

const AUTO_ADVANCE_MS = 400;

export default function LaunchChoiceStep({
    title,
    subtitle,
    options,
    selectedValue,
    onSelect,
    onBack,
    otherText = '',
    onOtherTextChange,
    otherPlaceholder = 'Tell us more…',
}) {
    const [pendingValue, setPendingValue] = useState(null);
    const advanceTimerRef = useRef(null);

    useEffect(() => () => {
        if (advanceTimerRef.current) {
            clearTimeout(advanceTimerRef.current);
        }
    }, []);

    const [localSelected, setLocalSelected] = useState(selectedValue);

    useEffect(() => {
        setLocalSelected(selectedValue);
    }, [selectedValue]);

    const handleOptionClick = (value) => {
        if (pendingValue) return;

        if (value === 'other') {
            setLocalSelected('other');
            return;
        }

        setPendingValue(value);
        advanceTimerRef.current = setTimeout(() => {
            onSelect(value);
            setPendingValue(null);
        }, AUTO_ADVANCE_MS);
    };

    const handleOtherContinue = () => {
        const trimmed = (otherText || '').trim();
        if (trimmed.length < 2) return;
        onSelect('other', trimmed);
    };

    const showOtherInput = localSelected === 'other';

    return (
        <div className="launch-step launch-choice-step">
            <h1>{title}</h1>
            {subtitle && <p className="step-subtitle">{subtitle}</p>}

            <div className="launch-choice-list" role="listbox" aria-label={title}>
                {options.map((opt) => {
                    const isSelected = localSelected === opt.value || pendingValue === opt.value;
                    return (
                        <button
                            key={opt.value}
                            type="button"
                            role="option"
                            aria-selected={isSelected}
                            className={`launch-choice-card ${isSelected ? 'selected' : ''} ${pendingValue === opt.value ? 'advancing' : ''}`}
                            onClick={() => handleOptionClick(opt.value)}
                            disabled={Boolean(pendingValue && pendingValue !== opt.value)}
                        >
                            {opt.label}
                        </button>
                    );
                })}
            </div>

            {showOtherInput && (
                <div className="launch-choice-other">
                    <input
                        type="text"
                        className="launch-input"
                        placeholder={otherPlaceholder}
                        value={otherText}
                        onChange={(e) => onOtherTextChange(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                handleOtherContinue();
                            }
                        }}
                        maxLength={256}
                        autoFocus
                    />
                    <button
                        type="button"
                        className="launch-btn primary"
                        onClick={handleOtherContinue}
                        disabled={(otherText || '').trim().length < 2}
                    >
                        Continue →
                    </button>
                </div>
            )}

            {onBack && (
                <button type="button" className="launch-btn secondary launch-choice-back" onClick={onBack}>
                    ← Back
                </button>
            )}
        </div>
    );
}
